import { ExpandMore, UnfoldMore } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Agreements } from '../../../../types/Agreements.types';
import { TableCell, TableRow } from '@mui/material';
import {
  arrowStyling,
  arrowStylingDefault,
  SortableHeaderButton,
} from '../../../../components/TableHeaderButton';

type AgreementsTableHeaderRowProps = {
  order: 'asc' | 'desc';
  orderBy: keyof Agreements;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Agreements
  ) => void;
};

export const AgreementsTableHeader = ({
  order,
  orderBy,
  onRequestSort,
}: AgreementsTableHeaderRowProps) => {
  const { t } = useTranslation();

  const getArrowIcon = (key: keyof Agreements) => {
    if (orderBy === key) {
      return order === 'asc' ? (
        <ExpandMore fontSize="small" style={arrowStyling} />
      ) : (
        <ExpandMore fontSize="small" style={arrowStylingDefault} />
      );
    }
    return <UnfoldMore fontSize="small" style={arrowStylingDefault} />;
  };

  return (
    <TableRow>
      <TableCell align="left" width="20%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'publisher')}
          sx={{ justifyContent: 'left' }}
          isSorted={orderBy === 'publisher'}
          sortDirection={order}
        >
          {t('agreements.table.publisher')}
          {getArrowIcon('publisher')}
        </SortableHeaderButton>
      </TableCell>
      <TableCell align="left" width="20%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'name')}
          sx={{ justifyContent: 'left' }}
          isSorted={orderBy === 'name'}
          sortDirection={order}
        >
          {t('agreements.table.title')}
          {getArrowIcon('name')}
        </SortableHeaderButton>
      </TableCell>
      <TableCell align="left" width="20%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'start_date')}
          isSorted={orderBy === 'start_date'}
          sortDirection={order}
        >
          {t('agreements.table.startDate')}
          {getArrowIcon('start_date')}
        </SortableHeaderButton>
      </TableCell>
      <TableCell align="left" width="20%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'end_date')}
          isSorted={orderBy === 'end_date'}
          sortDirection={order}
        >
          {t('agreements.table.endDate')}
          {getArrowIcon('end_date')}
        </SortableHeaderButton>
      </TableCell>
      <TableCell align="center" width="10%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'computed_status')}
          sx={{ justifyContent: 'center', textAlign: 'center' }}
          isSorted={orderBy === 'computed_status'}
          sortDirection={order}
        >
          {t('agreements.table.status')}
          {getArrowIcon('computed_status')}
        </SortableHeaderButton>
      </TableCell>
      <TableCell align="center" width="10%">
        <SortableHeaderButton
          variant="secondary"
          onClick={(event) => onRequestSort(event, 'journals_count')}
          isSorted={orderBy === 'journals_count'}
          sortDirection={order}
        >
          {t('agreements.table.numberOfJournals')}
          {getArrowIcon('journals_count')}
        </SortableHeaderButton>
      </TableCell>
    </TableRow>
  );
};
